import React, { FC, useState } from "react";
import { ContainerEyeStyled, ContainerPasswordStyled, PasswordInput } from "./style";
import { useLoginContext } from "context/login-context";
import { IErrorMessageLogin } from "models/login";
import validator from "validator";

interface CustomPasswordInputProps {
    changeLogin: (field: string, value: string) => void;
    passwordData: string;
    disabled: boolean;
}

const CustomPasswordInput: FC<CustomPasswordInputProps> = ({ changeLogin, passwordData, disabled }) => {

    const { loginData, errorMessage, setErrorMessage } = useLoginContext();
    const [showPassword, setShowPassword] = useState<boolean>(false);

    const onChange = (event) => {
        changeLogin("password", event.target.value);

        if (validator.isEmail(loginData.email)) {
            setErrorMessage('');
        } else if (!validator.isEmail(loginData.email) && loginData.email !== '') {
            setErrorMessage(IErrorMessageLogin.EMAIL_FORMATO_INVALIDO);
        }
    }

    return (
        <ContainerPasswordStyled>
            <PasswordInput
                id="password-login-input"
                label="Senha"
                type={showPassword ? 'text' : 'password'}
                fullWidth
                InputProps={{
                    disableUnderline: true,
                }}
                onChange={onChange}
                disabled={disabled}
                value={passwordData}
                error={!!(errorMessage && errorMessage === IErrorMessageLogin.INFOS_INCORRETAS)}
            />
            {passwordData !== '' ?
                <ContainerEyeStyled onMouseDown={() => setShowPassword(true)} onMouseUp={() => setShowPassword(false)}>
                    {showPassword ? 'Ocultar' : 'Mostrar'}
                </ContainerEyeStyled>
                :
                null
            }
        </ContainerPasswordStyled>
    )
}

export default CustomPasswordInput;